import { Title } from '@/ui/components/Title'
import React from 'react'

export const ArchiveHeader = ({
  title,
  introText,
  titleHierarchy,
}: {
  title?: string
  introText?: string
  titleHierarchy?: 'h2' | 'h1' | 'h3' | 'h4' | 'h5' | 'h6' | null
  buttonLink?: string | null
  buttonLabel?: string | null
}) => {
  if (!title && !introText) return null

  return (
    <div className="mb-8">
      {title && (
        <Title hierarchy={titleHierarchy} className="mb-2">
          {title}
        </Title>
      )}
      {introText && <p className="text-body-S text-text-default mb-4">{introText}</p>}
    </div>
  )
}
